const faq = () => {
    $('#faq-categories>ul>li:first-child>div.btn-tag').addClass('active');
    $('.tab-content:first-child').addClass('active');

    $('#faq-categories>ul>li>div.btn-tag').on('click', (e) => {
        $("#faq-categories>ul>li>div.btn-tag").removeClass("active");
        $(e.target).addClass('active');

        $(".tab-content").removeClass('active');
        $('.tab-content.'+e.target.id).addClass('active');

        return false;
    })
};

module.exports = faq;